/*
 * @Descripttion: 
 * @version: 
 * @Author: somebody
 * @Date: 2019-11-21 14:58:03
 * @LastEditors: kanhin
 * @LastEditTime: 2024-06-05 14:35:04
 */
import { message, Modal } from 'antd';
import moment from "moment";
import { browserHistory } from 'react-router';
// import sgiConfig from '../sgiConfig/sgiConfig';
import sgiConstants from '../sgiConstants/sgiConstants';
import { ComponentManager } from '../sgiFactory/ComponentManager';
import { sgiLocalStorage } from './localStorage';
import { ObjFactory } from '../sgiFactory/ObjFactory';
import * as sgiClient from './sgiClient';
import * as sgiCommon from './sgiCommon';
import { sgiLogger } from './sgiLogger';
import { StandardCode } from '../sgiFactory/StandardCode';
const confirm = Modal.confirm; //使用 confirm() 可以快捷地弹出确认框

/**
 * 导入全局Moment
 * @namespace 全局使用moment对象
 * @alias Moment
 */
var Moment = moment;
window.Moment = Moment;

/**
 * 
 * @param {*} ctl 
 * 
 * @ignore
 */
let refModalFunction = function (ctl) {

	if (!ctl) {
		return;
	}
	let { moduleDesc, objFct } = ctl.props;
	let mainComp = ComponentManager.get(objFct.getUID(), objFct.getUID());
	mainComp.setModal(ctl);
}
/**
 * 弹出组件与父组件使用不同对象工厂时使用
 * @param {*} ctl 
 * 
 * @ignore
 */
let refModalFunction2 = function (ctl) {

	if (!ctl) {
		return;
	}
	let { moduleDesc, objFct } = ctl.props;
	let pObjFct = objFct.getParent();
	if (pObjFct) {
		let mainComp = ComponentManager.get(pObjFct.getUID(), pObjFct.getUID());
		mainComp.setModal(ctl);
	}
}

/**
 * tool工具函数,全局方法
 * @namespace 通用工具函数.
 */
var tool = {//注意：这里暂时不能使用let，否则jsdoc-toolkit没办法正确识别构建jsdoc帮助文档！ [hanzb 2020-4-2]

	/**
	 * @namespace 全局变量
	 */
	Global: {
		/**
		 * 当前系统ap值
		 */
		// currentAP: sgiLocalStorage.get('currentAP') || sgiConfig.currentAP
		currentAP: sgiSrvUrl.currentAP
	},
	sgiStorage: sgiLocalStorage,
	sgiLogger: sgiLogger,
	/**
	 * 根据组件标识cid，获取组件实例
	 * @param {string} cid 组件标识
	 * @param {ObjFactory} objFct 对象工厂
	 * @returns {object} 组件实例
	 *  
	 * @group ctl
	 * @example 例：
	 * let panel = tool.getCmp("cid_panel_left", objFct);
	 */
	getCmp: function (cid, objFct) {
		if (!cid || !objFct) {
			return;
		}
		let uid = objFct.getUID();
		if (!uid) {
			return;
		}
		return ComponentManager.get(uid, cid);
	},
	/**
	 * 根据wv/form组件id刷新wv/form数据
	 * @param {string} wvId wv/form组件标识id
	 * @param {ObjFactory} objFct 对象工厂
	 * @returns {boolean} 刷新是否成功 刷新成功：true 刷新失败：false
	 * 
	 * @group form
	 * @example 例:
	 * objFct.set("db_wv_condition", {});
	 * tool.refreshWV("cid_wv_condition", objFct);
	 */
	refreshWV: function (wvId, objFct) {
		if (!wvId || !objFct) {
			return false;
		}
		let uid = objFct.getUID();
		if (!uid) {
			return false;
		}
		let wv = ComponentManager.get(uid, wvId);
		if (wv) {
			if (wv.props.setActiveWV) {
				wv.props.setActiveWV(wvId);
			}
			wv.refreshValues();
			return true;
		}
	},
	/**
	 * 通用控件刷新，支持form、表格、树、平铺、echarts
	 * @param {string} ctlId 组件id
	 * @param {ObjFactory} objFct 对象工厂实例
	 * @param {boolean} clearFlg 清空勾选标识
	 * 
	 * @group _global_
	 * @example
	 * 刷新form：
	 * objFct.set("db_wv_condition", {});
	 * tool.commonRefresh("cid_wv_condition", objFct);
	 * 
	 * 刷新树：
	 * objFct.set("db_tr_prm", []);
	 * tool.commonRefresh("cid_tr_prm", objFct);
	 * // tool.commonRefresh("cid_tr_prm", objFct, true);// 带checkbox勾选的树，清空上次勾选
	 * 
	 * 刷新表格：
	 * objFct.set("db_tb_prm", []);
	 * tool.commonRefresh("cid_tb_prm", objFct);
	 * // tool.commonRefresh("cid_tb_prm", objFct, true);// 带checkbox勾选的表格，清空上次勾选
	 * 
	 * 刷新平铺/echarts：
	 * objFct.set("db_list_prm", []);
	 * tool.commonRefresh("cid_list_prm", objFct);
	 */
	commonRefresh: function (ctlId, objFct, clearFlg) {
		if (!ctlId || !objFct) return;

		let ctl = this.getCmp(ctlId, objFct);
		if (!ctl) return;

		// 刷新form
		if (ctl.refreshValues) {
			if (ctl.props.setActiveWV) ctl.props.setActiveWV(ctlId);
			ctl.refreshValues();
			return;
		}
		// 刷新树
		if (ctl.refreshTree) {
			let treeData = objFct.get(ctl.state.insName) || [];
			if (clearFlg) ctl.state.checkedNodes = [];
			ctl.refreshTree(treeData);
			return;
		}
		// 刷新表格
		if (ctl.refreshTable) {
			let tableData = objFct.get(ctl.state.insName) || [];
			ctl.refreshTable(tableData);
			if (clearFlg) ctl.state.selectedRows = [];
			return;
		}
		// 刷新平铺/echarts
		if (ctl.refreshByData) {
			let data = objFct.get(ctl.state.insName) || [];
			ctl.refreshByData(data);
			return;
		}
	},
	/**
	 * 刷新dv控件，动态更新绑定dvid或者绑定dv描述
	 * @param {string} ctlId dv控件id
	 * @param {string|object} bdDv 绑定dvid或者绑定dv描述
	 * @param {ObjFactory} objFct 对象工厂
	 * 
	 * @group dv
	 * @example
	 * 动态更新绑定dvid：
	 * tool.refreshDVByBdDv("cid_dv_cond", "sd_DSD_1199619114738384896_0001", objFct);
	 * 动态更新dv描述：
	 * // 组装一个参数
	 * // let dvPrm = {
	 * // 	cldSet: [
	 * // 		{ desId: "EP_EO_UI_3101", c: "code", te: "编码" },
	 * // 		{ desId: "EP_EO_UI_3107", c: "gender", te: "性别", scId: "sd_SC_common_0001" },
	 * // 	]
	 * // };
	 * let dvPrm = PrmFactory.getPrm("sd_DSD_1199619114738384896_0001"); // 查询一个参数
	 * tool.refreshDVByBdDv("cid_dv_cond", dvPrm, objFct);
	 */
	refreshDVByBdDv: function (ctlId, bdDv, objFct) {
		if (!ctlId || !bdDv || !objFct) return;
		let ctl = this.getCmp(ctlId, objFct);
		if (ctl) {
			ctl.refreshByBdDv(bdDv);
		}
	},
	/**
	 * 刷新tv控件，动态更新绑定tvid或者绑定tv描述
	 * @param {string} ctlId tv控件id
	 * @param {string|object} bdTv 绑定tvid或者绑定的tv描述
	 * @param {ObjFactory} objFct 对象工厂
	 * 
	 * @group tv
	 * @example
	 * 动态更新绑定tvid：
	 * tool.refreshTVByBdTv("cid_tv_result", "sd_DSD_1199619114738384896_0001", objFct);
	 * 动态更新tv描述：
	 * // 组装一个参数
	 * // let tvPrm = {
	 * // 	cldSet: [
	 * // 		{ desId: "EP_EO_UI_3101", c: "code", te: "编码", isEd: true },
	 * // 		{ desId: "EP_EO_UI_3107", c: "gender", te: "性别", scId: "sd_SC_common_0001" },
	 * // 	]
	 * // };
	 * let tvPrm = PrmFactory.getPrm("sd_DSD_1199619114738384896_0001"); // 查询一个参数
	 * tool.refreshTVByBdTv("cid_tv_result", tvPrm, objFct);
	 */
	refreshTVByBdTv: function (ctlId, bdTv, objFct) {
		if (!ctlId || !bdTv || !objFct) return;
		let ctl = this.getCmp(ctlId, objFct);
		if (ctl) {
			ctl.refreshByBdTv(bdTv);
		}
	},
	/**
	 * 动态刷新嵌入面板
	 * @param {string} ctlId 嵌入面板id
	 * @param {string|object} ui 嵌入UI的guid或描述
	 * @param {ObjFactory} objFct 对象工厂
	 * 
	 * @group nest
	 * @example
	 * 动态更新绑定页面guid：
	 * tool.refreshNestByUI("cid_nt_dynamic", "sd_UI_common_0001", objFct);
	 * 动态更新绑定页面描述：
	 * // 组装一个参数
	 * // let prm = {
	 * // 	desId: "EP_EO_UI_0001",
	 * // 	ctlN: "UCV",
	 * // 	cldSet: [
	 * // 		{ desId: "EP_EO_UI_4001", ctlN: "普通面板" },
	 * // 		{ desId: "EP_EO_UI_4101", ctlN: "分割面板" },
	 * // 	]
	 * // };
	 * let prm = PrmFactory.getPrm("sd_UI_common_0001"); // 查询一个参数
	 * tool.refreshNestByUI("cid_nt_dynamic", prm, objFct);
	 */
	refreshNestByUI: function (ctlId, ui, objFct) {
		if (!ctlId || !ui || !objFct) return;
		let ctl = this.getCmp(ctlId, objFct);
		if (ctl) {
			ctl.refreshByUI(ui);
		}
	},
	/**
	 * 根据wv/form组件id校验表单信息合法性
	 * @param {string} wvid wv/form组件id
	 * @param {ObjFactory} objFct 对象工厂
	 * @returns {boolean} true-合法，false-不合法
	 * 
	 * @group form
	 * @example
	 * let flag = tool.isValid("cid_dv_info", objFct);
	 * if (!flag) {
	 * 	tool.popMessage("输入项不符合要求，请检查后重新输入！", "warning");
	 * 	return;
	 * }
	 */
	isValid: function (wvid, objFct) {
		var wv = this.getCmp(wvid, objFct);
		if (!wv || !wv.validateFields) {
			return false;
		}
		return wv.validateFields();
	},

	/**
	 * 设置form组件是否为仅显示样式
	 * @author hanzb
	 * @param {String} wvid 表单id
	 * @param {boolean} isLabel 是否仅显示
	 * @param {ObjFactory} objFct 对象工厂
	 * 
	 * @group form
	 * @example
	 * // 设置整个表单为仅显示样式
	 * tool.setFormIsLabel("cid_dv_info", true, objFct);
	 * // 取消仅显示
	 * tool.setFormIsLabel("cid_dv_info", false, objFct);
	 */
	setFormIsLabel: function (wvid, isLabel, objFct) {
		const wv = this.getCmp(wvid, objFct);
		if (!wv || !wv.setIsLabel) return;
		wv.setIsLabel(isLabel);
	},

	/**
	 * 设置文件控件 还原方法
	 * @author wangz
	 * @param {String} wvid 表单id
	 * @param {boolean} isLabel 是否仅显示
	 * @param {ObjFactory} objFct 对象工厂
	 * 
	 * @group upload
	 * @example
	 * let fileList = [];
	 * encls.forEach(e => fileList.push({
	 * 	url: e.enclUrl, //文件地址，必须
	 * 	name: e.enclNam, //文件名称，必须
	 * 	uid: e.enclId, //id，必须
	 * 	status: "done", //文件状态，必须
	 * }));
	 * tool.setFileList('id_upload_reqCollect_encl', fileList, objFct);
	 */
	setFileList: function (wvid, fileList, objFct) {
		const fileCtl = this.getCmp(wvid, objFct);
		if (!fileCtl) return;
		fileCtl.setFileList(fileList);
	},

	/**
	 * 按钮控件添加角标
	 * @param {String} buttonId 按钮id
	 * @param {*} badge 角标
	 * @param {ObjFactory} objFct 对象工厂实例
	 * 
	 * @group button
	 * @example
	 * tool.setBadge("cid_btn", 5, objFct);
	 */
	setBadge: function (buttonId, badge, objFct) {
		let button = this.getCmp(buttonId, objFct);
		if (!button || !button.setBadge) return;
		button.setBadge(badge);
	},

	/**
	 * 弹出单按钮文本信息对话框
	 * @param {string} title 对话框标题
	 * @param {string} msg 对话框文本内容
	 * @param {function} callbackClose 对话框关闭事件
	 * @param {info|success|error|warning|confirm} [state="info"] 对话框类型,显示图标不同，默认info
	 * @param {string} [okText="确定"] 确认按钮文本内容，默认确定
	 * 
	 * @group _global_
	 * @example
	 * // 默认对话框提示
	 * tool.popMsgDialog("title", "message");
	 * // 等同于
	 * tool.popMsgDialog("title", "message", onClose, "info", "okText");
	 * // 成功提示
	 * tool.popMsgDialog("title", "message", onClose, "success", "okText");
	 * // 警告提示
	 * tool.popMsgDialog("title", "message", onClose, "warning", "okText");
	 * // 错误提示
	 * tool.popMsgDialog("title", "message", onClose, "error", "okText");
	 * // 确认提示
	 * tool.popMsgDialog("title", "message", onClose, "confirm", "okText");
	 */
	popMsgDialog: function (title, msg, callbackClose, state, okText) {
		var something = {
			title: title,
			content: msg,
			onOk: callbackClose,
			okText: okText
		};
		switch (state) {
			case "info":
			default:
				Modal.info(something);
				break;
			case "success":
				Modal.success(something);
				break;
			case "error":
				Modal.error(something);
				break;
			case "warning":
				Modal.warning(something);
				break;
			case "confirm":
				Modal.confirm(something);
				break;
		}
	},
	/**
	 * 弹出双按钮确认对话框
	 * @param {string} title 对话框标题
	 * @param {string} msg 对话框内容
	 * @param {function} callbackCancel 取消按钮点击回调函数
	 * @param {function} callbackConfirm 确认按钮点击回调函数
	 * @param {string} [cancelText="取消"] 取消按钮文字，默认：取消
	 * @param {string} [okText="确定"] 确认按钮文字，默认：确定
	 * 
	 * @group _global_
	 * @example
	 * tool.popConfirmDialog("title", "content", onCancel, onConfirm, "cancelText", "okText");
	 */
	popConfirmDialog: function (title, msg, callbackCancel, callbackConfirm, cancelText, okText) {
		confirm({
			title: title,
			content: msg,
			onCancel: callbackCancel,
			onOk: callbackConfirm,
			cancelText: cancelText,
			okText: okText,
		});
	},
	/**
	 * loading提示，带有mask遮罩
	 * @param {string} msg loading提示信息
	 * @returns {Modal.info} 销毁时调用info.destroy();
	 * 
	 * @group _global_
	 * @example
	 * // 提示loading
	 * let loading = tool.popLoading("message");
	 * // 销毁
	 * loading.destroy();
	 */
	popLoading: function (msg) {
		return Modal.info({
			content: msg,
			icon: "loading",
			className: "sgiLoading",
			okButtonProps: { style: { display: "none" } },
			cancelButtonProps: { style: { display: "none" } },
			height: undefined,
			width: "fit-content"
		});
	},
	/**
	 * 信息提示
	 * @param {string} content 提示内容
	 * @param {success|error|info|warning|warn|loading} [state="info"] 提示的类型，默认“info”
	 * @param {function} [onClose] 关闭事件
	 * @param {number} [duration=3] 自动关闭延时，默认3秒
	 * 
	 * @group _global_
	 * @example 
	 * // 成功提示
	 * tool.popMessage("some message", "success");
	 * // 错误提示
	 * tool.popMessage("some message", "error");
	 * // loading提示
	 * let hide = tool.popMessage("some message", "loading", onClose, 5);
	 * // 主动关闭loading
	 * hide();
	 */
	popMessage: function (content, state, onClose, duration) {

		// 设置最大显示数, 超过限制时，最早的消息会被自动关闭
		message.config({ maxCount: sgiConfig.popMessageMaxCount || 1 });

		let result;
		switch (state) {
			case "info":
			default:
				result = message.info(content, duration, onClose);
				break;
			case "success":
				result = message.success(content, duration, onClose);
				break;
			case "error":
				result = message.error(content, duration, onClose);
				break;
			case "warning":
				result = message.warning(content, duration, onClose);
				break;
			case "warn":
				result = message.warn(content, duration, onClose);
				break;
			case "loading":
				result = message.loading(content, duration, onClose);
				break;
		}
		return result;
	},
	/**
	 * 通用的弹出窗体，使用任何页面作为弹出窗，可以指定高度宽度
	 * @param {string} uid 页面guid
	 * @param {ObjFactory} objFct 对象工厂
	 * @param {string} [curtitle] 指定标题
	 * @param {number|string} [width] 指定宽度
	 * @param {number|string} [height] 指定高度
	 * 
	 * @group _global_
	 * @example
	 * // 普通调用
	 * tool.popUI("guid", objFct, "tittle");
	 * // 控制宽高
	 * tool.popUI("guid", objFct, "tittle", width, height);
	 */
	popUI: function (uid, objFct, curtitle, width, height) {
		var mainComp = this.getCmp(objFct.getUID(), objFct);
		mainComp.addModalByProps({
			ref: refModalFunction,
			onCancel: mainComp.removeModal.bind(mainComp),
			key: sgiCommon.uuid(8),
			uid: uid,
			objFct: objFct,
			curtitle: curtitle,
			visible: true,
			width: width,
			height: height
		});
		// <SgiModal
		// 	ref={refModalFunction}
		// 	onCancel={mainComp.removeModal.bind(mainComp)}
		// 	key={sgiCommon.uuid(8)} uid={uid} objFct={objFct}
		// 	curtitle={curtitle} visible={true}
		// 	width={width} height={height} />);

		mainComp.setState({ loading: false });
	},
	/**
	 * 【独立对象工厂】通用的弹出窗体，使用任何页面作为弹出窗，可以指定高度宽度
	 * @param {string} uid 页面id
	 * @param {ObjFactory} objFct 对象工厂
	 * @param {string} [curtitle] 指定标题
	 * @param {object} [transferData] 新对象工厂需要赋的初始值
	 * @param {number|string} [width] 指定宽度
	 * @param {number|string} [height] 指定高度
	 * 
	 * @group _global_
	 * @example
	 * // 独立对象工厂，普通调用
	 * tool.popUI2("guid", objFct, "tittle", { record });
	 * // 控制宽高
	 * tool.popUI2("guid", objFct, "tittle", { record }, width, height);
	 */
	popUI2: function (uid, objFct, curtitle, transferData, width, height) {
		var mainComp = this.getCmp(objFct.getUID(), objFct);
		let newObjFct = new ObjFactory(uid, transferData, objFct);
		mainComp.addModalByProps({
			ref: refModalFunction2,
			onCancel: mainComp.removeModal.bind(mainComp),
			key: sgiCommon.uuid(8),
			uid: uid,
			objFct: newObjFct,
			curtitle: curtitle,
			visible: true,
			width: width,
			height: height
		});
		// mainComp.addModal(
		// 	<SgiModal
		// 		ref={refModalFunction2}
		// 		onCancel={mainComp.removeModal.bind(mainComp)}
		// 		key={sgiCommon.uuid(8)} uid={uid} objFct={newObjFct}
		// 		curtitle={curtitle} visible={true}
		// 		width={width} height={height} />);

		mainComp.setState({ loading: false });
	},
	/**
	 * 通用页面切换，由各平台自行实现
	 * @param {string} uid 页面guid
	 * @param {object} transferData 像新页面对象工厂传递的json数据
	 * @param {string} [curtitle] 指定标题
	 * @abstract 各平台自行实现
	 * 
	 * @group _global_
	 * @example
	 * tool.popUIByUcv("sd_UI_common_0001", { record }, "xxx页面");
	 */
	popUIByUcv: function (uid, transferData, curtitle) {
		//由相应的平台自主实现,无法做公共的
	},
	/**
	 * 关闭最后一个弹出窗体
	 * @param {ObjFactory} objFct 对象工厂
	 * 
	 * @group _global_
	 * @example
	 * // 相同对象工厂
	 * tool.popClose(objFct);
	 * // 不同对象工厂
	 * let pObjFct = objFct.getParent();
	 * tool.popClose(pObjFct);
	 */
	popClose: function (objFct) {
		var mainComp = this.getCmp(objFct.getUID(), objFct);
		var sgiModal = mainComp.getModal();
		if (!sgiModal) {
			return;
		}
		sgiModal.onCancel();
		mainComp.removeModal();
		mainComp.setState({ loading: false });
	},

	/**
	 * 现行事件集外部调用方法
	 * @param {string} name 事件集中函数调用名
	 * @param {ObjFactory} objFct 对象工厂
	 * @param  {...any} args 要向调用的方法中传入的参数
	 * 
	 * @group _global_
	 * @example
	 * tool.callFun("init", objFct, arg1, arg2, arg3...);
	 */
	callFun: function (name, objFct, ...args) {
		sgiLogger.debug(`[callFun]执行事件集方法[${name}]`);
		if (!name || !objFct) {
			sgiLogger.debug(`[callFun]：传入参数【name】或【objFct】为空`);
			return;
		}
		let funs = objFct.get("@funs");
		if (funs && funs[name] && typeof funs[name] === "function") return funs[name](...args);
		else sgiLogger.debug(`[callFun]：找不到方法名为【${name}】的方法，请检查事件集中是否存在其定义`);
	},

	/**
	 * 现行事件集常量外部获取方法
	 * @param {string} name 事件集中常量名
	 * @param {ObjFactory} objFct 对象工厂
	 * 
	 * @group _global_
	 * @example
	 * let AP = tool.getConst("AP", objFct);
	 */
	getConst: function (name, objFct) {
		sgiLogger.debug(`[getConst]获取常量[${name}]`);
		if (!name || !objFct) {
			sgiLogger.debug(`[getConst]：传入参数【name】或【objFct】为空`);
			return;
		}
		let cnsts = objFct.get("@cnsts") || {};
		return cnsts[name];
	},

	/**
	 * 递归遍历所有节点，执行foreach【注意：请勿操作childName对应结构，否则可能造成死循环】（注意：不会中断，全部遍历）
	 * @param {Array} [items=[]] 需要遍历的json数组，可以带层级
	 * @param {Function} foreach 遍历到的每一项执行的操作，function(item,index,arr)
	 * @param {string} [childName="cldSet"] 层级结构属性名，默认“cldSet”
	 * 
	 * @group _global_
	 * @example
	 * tool.itemForEach(items, (item, index, arr) => {  每一项的操作  });
	 */
	itemForEach: function (items = [], foreach, childName = "cldSet") {
		if (!foreach || typeof foreach !== "function") {
			sgiLogger.debug(`tool方法[itemForEach]：传入函数【foreach】为空`);
			return;
		}
		items.forEach((item, index, arr) => {
			foreach(item, index, arr);
			let cldSet = item[childName];
			if (cldSet && cldSet.length > 0) this.itemForEach(cldSet, foreach, childName);
		});
	},
	/**
	 * 递归遍历(every遍历)所有节点，执行foreach（注意：返回false则中断）
	 * @param {Array} [items=[]] 需要遍历的json数组，可以带层级
	 * @param {Function} foreach 遍历到的每一项执行的操作，function(item,index,arr)
	 * @param {string} [childName="cldSet"] 层级结构属性名，默认“cldSet”
	 * 
	 * @group _global_
	 * @example
	 * tool.itemForEvery(items, (item, index, arr) => {  每一项的操作，返回false终止  });
	 */
	itemForEvery: function (items = [], foreach, childName = "cldSet") {
		if (!foreach || typeof foreach !== "function") {
			sgiLogger.debug(`tool方法[itemForEvery]：传入函数【foreach】为空`);
			return;
		}
		items.every((item, index, arr) => {
			if (!foreach(item, index, arr)) return false;
			let cldSet = item[childName];
			if (cldSet && cldSet.length > 0) {
				if (!this.itemForEvery(cldSet, foreach, childName)) return false;
			}
		});
	},
	/**
	 * 递归遍历(some遍历)所有节点，执行foreach（注意：返回true则中断）
	 * @param {Array} [items=[]] 需要遍历的json数组，可以带层级
	 * @param {Function} foreach 遍历到的每一项执行的操作，function(item,index,arr)
	 * @param {string} [childName="cldSet"] 层级结构属性名，默认“cldSet”
	 * 
	 * @group _global_
	 * @example
	 * tool.itemForEvery(items, (item, index, arr) => {  每一项的操作，返回true终止  });
	 */
	itemForSome: function (items = [], foreach, childName = "cldSet") {
		if (!foreach || typeof foreach !== "function") {
			sgiLogger.debug(`tool方法[itemForSome]：传入函数【foreach】为空`);
			return;
		}
		items.some((item, index, arr) => {
			if (foreach(item, index, arr)) return true;
			let cldSet = item[childName];
			if (cldSet && cldSet.length > 0) {
				if (this.itemForSome(cldSet, foreach, childName)) return true;
			}
		});
	},

	/**************** 以上弹出窗部分 ****************/
	/**************** 以下浏览器跳转部分 ****************/

	/**
	 * 路由跳转
	 * @param {string} pathname 路径path
	 * @param {object} [data] state
	 * 
	 * @group _global_
	 * @example
	 * tool.browserPush("/dev/UIEditor", { record });
	 */
	browserPush: function (pathname, data) {
		if (!pathname) {
			return;
		}
		browserHistory.push({
			pathname: pathname,
			state: data
		});
	},

	/**
	 * 
	 * @param {*} contentOrPath 
	 * @param {*} fileName 
	 * 
	 * @ignore
	 */
	IEdownloadFile: function (contentOrPath, fileName) {
		if (!contentOrPath) {
			return;
		}
		var aLink = document.createElement("a"), evt = document.createEvent("MouseEvent");

		evt.initEvent("click", false, false);
		if (fileName) {
			aLink.download = fileName;
		}
		aLink.href = contentOrPath;
		aLink.dispatchEvent(evt);
	},
	/**
	 * 	
	 * @param {*} contentOrPath 
	 * @param {*} fileName 
	 * 
	 * @ignore
	 */
	downloadFile: function (contentOrPath, fileName) {
		var imgPath = "download?path=" + contentOrPath;
		this.IEdownloadFile(imgPath, fileName);
	},

	/**************** 以上浏览器跳转部分 ****************/
	/**************** 以下树控件方法部分 ****************/

	/**
	 * 刷新树
	 * @param {string} treeId 树控件id
	 * @param {ObjFactory} objFct 对象工厂
	 * @param {boolean} clearFlg 是否清除现有勾选
	 * 
	 * @group tree
	 * @example
	 * objFct.set("db_tr_prm", []);
	 * tool.commonRefresh("cid_tr_prm", objFct);
	 * // tool.commonRefresh("cid_tr_prm", objFct, true);// 带checkbox勾选的树，清空上次勾选
	 */
	refreshTree: function (treeId, objFct, clearFlg) {
		var tree = this.getCmp(treeId, objFct);
		if (!tree) {
			return;
		}
		var treeData = objFct.get(tree.state.insName);
		if (!treeData) {
			treeData = [];
		}
		if (clearFlg) tree.state.checkedNodes = [];
		tree.refreshTree(treeData);
	},
	/**
	 * 动态添加自定义菜单
	 * @param {string} treeId 树控件id
	 * @param {*} customMenuItems 例子：[{icon:'',mnCLsn:function("module", "objFct", "record", "treeNode"),te:''}]
	 * @param {*} flag 
	 * @param {ObjFactory} objFct 对象工厂
	 * 
	 * @group tree
	 * @example
	 * Probably the method added by Wangz
	 * //动态设置menu
	 * let menuList = [];
	 * bruSelData.forEach(element => {
	 *	 menuList.push({ icon: 'plus', mnCLsn: menuMnCLsn.bind(this, element.id), te: element.nam });
	 * });
	 * tool.addCustomMenuItems('cid_tree_xrainfo', menuList, false, objFct);
	 */
	addCustomMenuItems: function (treeId, customMenuItems, flag, objFct) {
		if (!treeId) {
			return;
		}
		var tree = this.getCmp(treeId, objFct);
		if (!tree) {
			return;
		}
		return tree.addCustomMenuItems(customMenuItems, flag);
	},
	/**
	 * 获取已选中/勾选节点
	 * @param  {string} treeId 树控件id
	 * @param  {ObjFactory} objFct 对象工厂
	 * @return {object[]} 已选中/勾选的节点数据数组
	 * 
	 * @group tree
	 * @example
	 * let list = tool.getSelection("cid_tr", objFct);
	 */
	getSelection: function (treeId, objFct) {
		var tree = this.getCmp(treeId, objFct);
		if (!tree) {
			return;
		}
		return tree.getSelection();
	},
	/**
	 * 选中树的某个节点
	 * @param  {string} treeId 树控件id
	 * @param  {object} record 树节点数据信息，含有key值
	 * @param  {ObjFactory} objFct 对象工厂
	 * 
	 * @group tree
	 * @example
	 * tool.select('SCprmsTree',record,objFct);
	 * record为单击事件中的record,结构如下:
	 * record = { _key:"……",
	 *			//_pKey:"……",
	 *			节点的数据信息}
	 */
	select: function (treeId, record, objFct) {
		var tree = this.getCmp(treeId, objFct);
		if (!tree) {
			return;
		}
		tree.select(record);
	},
	/**
	 * 选中树的某个节点
	 * @param {string} treeId 树控件id
	 * @param {object} record 树节点数据信息
	 * @param {string} key 查找节点依据key
	 * @param {ObjFactory} objFct 对象工厂
	 * 
	 * @group tree
	 * @example
	 * tool.selectByData("channelTree", prmClds[0], "channelCode", objFct);
	 */
	selectByData: function (treeId, record, key, objFct) {
		var tree = this.getCmp(treeId, objFct);
		if (!tree) {
			return;
		}
		let inRecords = tree.getTreeRecord(record, key);
		tree.select(inRecords[0]);
	},
	/**
	 * 选中首行树节点
	 * @param {string} treeId  树控件id
	 * @param {ObjFactory} objFct  对象工厂
	 * 
	 * @group tree
	 * @example
	 * tool.selFirst("id_org_tree_010010",objFct);
	 */
	selFirst: function (treeId, objFct) {
		var tree = this.getCmp(treeId, objFct);
		if (!tree) {
			return;
		}
		tree.selFirst();
	},
	/**
	 * 根据record checked树上这些节点
	 * key值如果不为空，遍历所有节点，根据key属性，找到与records相同的值，这些records checked
	 * 如果为空，默认这些record就是树上的records，直接选中
	 * @param {string} treeId 树控件id
	 * @param {object[]} records 要勾选的数组
	 * @param {string} key 勾选比对的key值
	 * @param {ObjFactory} objFct 对象工厂
	 * 
	 * @group tree
	 * @example
	 * tool.setTreeChecked("cid_tree", [{id:'1'}], 'id', objFct);
	 */
	setTreeChecked: function (treeId, records, key, objFct) {
		if (!records) return;
		var tree = this.getCmp(treeId, objFct);
		if (!tree) {
			return;
		}
		if (key) {
			let inRecords = tree.getTreeRecord(records, key);
			tree.setTreeChecked(inRecords);
		} else {
			tree.setTreeChecked(records);
		}
	},

	/**
	 * 动态设置树是否可以勾选
	 * @param {string} treeId 树id
	 * @param {boolean} checkable 是否可勾选
	 * @param {ObjFactory} objFct 对象工厂
	 * 
	 * @group tree
	 * @example
	 * tool.setTreeCheckable("cid_tree", true||fasle, objFct);
	 */
	setTreeCheckable: function (treeId, checkable, objFct) {
		var tree = this.getCmp(treeId, objFct);
		if (!tree) {
			return;
		}
		tree.setCheckable(checkable);
	},

	/**
	 * 获取树的勾选数据(树结构json数据)
	 * @param {string} treeId 树控件id
	 * @param {ObjFactory} objFct 对象工厂
	 * 
	 * @group tree
	 * @example
	 * tool.getTreeCheckData("cid_tree", objFct);
	 */
	getTreeCheckData: function (treeId, objFct) {
		var tree = this.getCmp(treeId, objFct);
		if (!tree) {
			return;
		}
		return tree.getCheckData();
	},
	/**
	 * 设置树的勾选数据(树结构json数据)
	 * @param {string} treeId 树控件id
	 * @param {object[]} checkData 树结构勾选数据
	 * @param {string} key 勾选比对的key值
	 * @param {ObjFactory} objFct 对象工厂
	 * @param {object[]} [treeData] 树数据数组
	 * 
	 * @group tree
	 * @example
	 * tool.setTreeCheckData("cid_tree", [{c:'1'}], "c", objFct);
	 */
	setTreeCheckData: function (treeId, checkData, key, objFct, treeData) {
		var tree = this.getCmp(treeId, objFct);
		if (!tree) {
			return;
		}
		return tree.setCheckData(checkData, key, treeData);
	},

	/**
	 * 展开树的某个节点
	 * @param  {string} treeId 树控件id
	 * @param  {object} record 树节点数据信息，含有key值
	 * @param  {ObjFactory} objFct 对象工厂
	 * 
	 * @group tree
	 * @example
	 * tool.expand('cid_tree_0002',record,objFct);
	 * record为单击事件中的record,结构如下:
	 * {
	 * 	_key: '...',
	 *  _pKey: '...',
	 *  其他数据信息
	 * }
	 */
	expand: function (treeId, record, objFct) {
		var tree = this.getCmp(treeId, objFct);
		if (!tree) {
			return;
		}
		tree.expand(record);
	},
	/**
	 * 展开树的某个节点
	 * @param  {string} treeId 树控件id
	 * @param  {ObjFactory} objFct 对象工厂
	 * 
	 * @group tree
	 * @example
	 * tool.expandAll('cid_tree_0002', objFct);
	 */
	expandAll: function (treeId, objFct) {
		var tree = this.getCmp(treeId, objFct);
		if (!tree) {
			return;
		}
		tree.expandAll();
	},
	/**
	 * 删除树的选中数据
	 * @param  {string} treeId 树控件id
	 * @param  {ObjFactory} objFct 对象工厂
	 * 
	 * @group tree
	 * @example
	 * tool.delTreeSel('cid_tree_0002', objFct);
	 */
	delTreeSel: function (treeId, objFct) {
		var tree = this.getCmp(treeId, objFct);
		if (!tree) {
			return;
		}
		tree.delTreeSel();
	},
	/**
	 * 删除树的一个节点
	 * @param  {string} treeId 树控件id
	 * @param  {object} node record节点数据信息
	 * @param  {ObjFactory} objFct 对象工厂
	 * 
	 * @group tree
	 * @example
	 * tool.delTreeNode('cid_tree_0002', record, objFct);
	 */
	delTreeNode: function (treeId, node, objFct) {
		var tree = this.getCmp(treeId, objFct);
		if (!tree) {
			return;
		}
		tree.delTreeNode(node);
	},
	/**
	* 获取所有叶子节点
	* @param {object} record 当前节点数据record
	* @param {string} [childCode="cldSet"] 子节点属性编码，默认“cldSet”
	* @returns {object[]} 返回的叶子节点数组
	* 
	* @group tree
	* @example
	* tool.getAllLeaf(treeRecord, 'cldSet');
	*/
	getAllLeaf: function (record, childCode) {
		if (!record) return null;
		let cldCode = childCode || "cldSet";
		let leaf = [];
		if (record[cldCode]) {
			let clds = record[cldCode];
			clds.forEach(cld => {
				let rLeaf = this.getAllLeaf(cld, childCode);//不+this调不到
				leaf.push(...rLeaf);
			});
		} else {
			leaf.push(record);
		}
		return leaf;
	},
	/**
	 * 根据列表数据组装树结构对象
	 * @param {object[]} datas  列表数据数组
	 * @param {string} id  节点属性key
	 * @param {string} pid  父节点属性key
	 * @param {string} treeId  树控件id
	 * @param {object} virtual  虚拟根节点对象，null时为无虚拟根节点
	 * @param {ObjFactory} objFct  对象工厂
	 * @returns {object[]} treeData 带有层级关系的树数据数组
	 * 
	 * @group _global_
	 * @example
	 * tool.ctTrStrByData(list, "id", "pid", "treeId", virtual, objFct);
	 */
	ctTrStrByData: function (datas, id, pid, treeId, virtual, objFct) {//eoid, 

		var treeData = {};
		// 刷新树，并放数据
		var tree = this.getCmp(treeId, objFct);
		let childrenName;
		if (tree) {
			childrenName = tree.state.childrenName;
			treeData = this.ctListToTreeJson(datas, id, pid, childrenName, virtual);
			tree.refreshTree(treeData);
			objFct.set(tree.state.insName, treeData);
		} else {
			treeData = this.ctListToTreeJson(datas, id, pid, null, virtual);
		}

		return treeData;
	},
	/**
	 * 根据列表数据组装树结构对象
	 * @param {object[]} datas  列表数据数组
	 * @param {string} id  节点属性key
	 * @param {string} pid  父节点属性key
	 * @param {string} treeId  树控件id
	 * @param {object} virtual  虚拟根节点对象，null时为无虚拟根节点
	 * @param {ObjFactory} objFct  对象工厂
	 * @returns {object[]} treeData 带有层级关系的树数据数组
	 * @example
	 * //表格树要正常显示 需要设置_key属性，react要求
	 * list.forEach(element => {
	 *	if (!element._key) element._key = tool.uuid(8);
	 * });
	 * list = tool.ctListToTreeJson(list, "requireId", "parentId", "children");
	 */
	ctListToTreeJson: function (datas, id, pid, childrenName, virtual) {//eoid, 
		if (!datas) {
			return [];
		}
		var tempNodes = datas.concat();

		if (!childrenName) childrenName = "cldSet";

		function createChild(node) {
			var curid = node && node[id];
			if (!curid) curid = "";
			// var childrenName = "cldSet";
			// if (tree && tree.state && tree.state.childrenName) childrenName = tree.state.childrenName;

			for (var i = 0; i < tempNodes.length; i++) {
				var record = tempNodes[i];
				if (!record)
					continue;
				var parentid = record[pid];
				if (!parentid) { parentid = ""; }
				if (parentid == curid) {// 是当前节点的子节点，添加到当前节点下。
					if (!node[childrenName]) {// 当前node下子节点为空
						node[childrenName] = [];
					}
					node[childrenName].push(record);
					tempNodes.splice(i, 1);
					i--;
				}
			}
			if (tempNodes.length > 0) {
				var childnodes = node[childrenName];
				if (childnodes) {
					var len = childnodes.length;
					for (var i = 0; i < len; i++) { // 对当前节点的子节点循环添加孙子节点。
						if (tempNodes.length <= 0) break;
						createChild(childnodes[i]);
					}
				}
			}
		}

		var treeData = {};
		if (virtual) {// 有虚拟根节点
			treeData = virtual;
		}
		createChild(treeData);

		if (virtual) {// 有虚拟根节点
			treeData = [treeData];
		} else {
			treeData = treeData[childrenName];
		}
		return treeData;
	},
	/**
	 * 将树节点数据转换为结构
	 * @param {string} treeId  树控件id
	 * @param {object} info  树节点数据，含有key值
	 * @param {ObjFactory} objFct  对象工厂
	 * 
	 * @group tree
	 * @example
	 * tool.cytNode('cid_tree', {_key:''}, objFct);
	 */
	cvtNode: function (treeId, info, objFct) {
		var tree = this.getCmp(treeId, objFct);
		if (!tree) {
			return;
		}
		return tree.cvtNode(info);
	},

	/**************** 以上树控件方法部分 ****************/
	/**************** 以下表格控件方法部分 ****************/

	/**
	 * 表格刷新方法
	 * @param {string} tableId 表格Id
	 * @param {ObjFactory} objFct 对象工厂
	 * @param {boolean} clearFlg 清理选中
	 * 
	 * @group table
	 * @example
	 * objFct.set("db_tb_prm", []);
	 * tool.refreshTable("cid_tb_prm", objFct);
	 * // tool.refreshTable("cid_tb_prm", objFct, true);// 带checkbox勾选的表格，清空上次勾选
	 */
	refreshTable: function (tableId, objFct, clearFlg) {
		var table = this.getCmp(tableId, objFct);
		if (!table) {
			return;
		}
		var tableData = objFct.get(table.state.insName);
		if (!tableData) {
			tableData = [];
		}
		table.refreshTable(tableData);

		// 清理选中
		if (clearFlg) {
			table.state.selectedRows = [];
		}
	},
	/**
	 * 修改表格选择类型
	 * @param  {string} tableId 表格控件id
	 * @param  {none|radio|checkbox} type 表格选择类型，none-无选择框，radio-单选原框，checkbox-复选方框
	 * @param  {ObjFactory} objFct 对象工厂
	 * 
	 * @group table
	 * @example
	 * tool.setTbSelType('cid_table', 'none'||'radio'||'checkbox', objFct);
	 */
	setTbSelType: function (tableId, type, objFct) {
		var table = this.getCmp(tableId, objFct);
		if (!table) {
			return;
		}
		table.setTbSelType(type);
	},

	// tableBatchSelect: function (tableId, fun, objFct, current) {
	//     var table = this.getCmp(tableId, objFct);
	//     if (!table) {
	//         return;
	//     }
	//     table.setBatchFun(fun);
	//     table.batchSelect(current);
	// },
	/**
	 * 表格分批服务调用
	 * @param {string} tableId 表格控件id
	 * @param {ObjFactory} objFct 对象工厂
	 * @param {string} path 服务访问url地址
	 * @param {any} data 发送的请求数据
	 * @param {function} callback 请求返回后的回调函数
	 * @param {boolean} [flag=false] 异步访问标识
	 * @param {number} [current=1] 当前表格页序号，默认1
	 * @param {string} [reqType="POST"] 服务请求类型，默认"POST"
	 * 
	 * @group table
	 * @example
	 * tool.tableBatchSelect("tableId", objFct, sgiConfig.service_program + "program/query", req, (res) => {
	 * 	if (res && res.head && res.head.code === "0000") {
	 * 		tool.sgiLogger.info("查询成功 res :", res);
	 * 		objFct.set("tableInst", res.body || []);
	 * 		tool.refreshTable("tableId", objFct);
	 * 	} else {
	 * 		tool.sgiLogger.error("查询失败 res :", res);
	 * 	}
	 * }, true);
	 */
	tableBatchSelect: function (tableId, objFct, path, data, callback, flag, current, reqType) {
		var table = this.getCmp(tableId, objFct);
		if (!table) {
			return;
		}
		table.setBatchInfo(path, data, callback, reqType, flag);
		// table.setBatchFun(callback);
		table.batchSelect(current || 1);
	},
	/**
	 * 表格分批服务调用
	 * @param {string} tableId 表格控件id
	 * @param {ObjFactory} objFct 对象工厂
	 * @param {string} SIID 服务接口id
	 * @param {boolean} [flag=false] 异步访问标识
	 * @param {number} [current=1] 当前表格页序号，默认1
	 * @param {function} callback 请求返回后的回调函数
	 * @param {string} [reqType="POST"] 服务请求类型，默认"POST"
	 * 
	 * @group table
	 * @example
	 * // 常规调用
	 * tool.tableBatchSelectSI("tableId", objFct, "sd_SI_group_2001000010", true);
	 * // 自定义调用
	 * tool.tableBatchSelectSI("tableId", objFct, "sd_SI_group_2001000010", true, 1, (res)=>{}, "POST");
	 */
	tableBatchSelectSIOld: function (tableId, objFct, SIID, flag, current = 1, callback, reqType) {
		let table = this.getCmp(tableId, objFct);
		if (!table) return;

		let prm = PrmFactory.getPrm(SIID);
		if (!prm || !prm.guid) return;

		let path = sgiConfig.service + "/" + prm.url;//服务地址

		let data, inInst, outInst;
		let cfgs = prm.cldSet || [];
		cfgs.some(cfg => {
			let io = cfg.iobType;//输入输出类型
			let instance = cfg.oKey;//实例名
			if (!inInst && io == "I") {
				inInst = instance;
				data = objFct.get(instance);
			}
			if (!outInst && io == "O") {
				outInst = instance;
			}
			return inInst && outInst;
		});

		let _callback = (res) => {
			// 成功，对象工厂赋值
			if (res && res.head && res.head.code == "0000") objFct.set(outInst, res.body);
			// 同上回调
			callback(res);
		};
		table.setBatchInfo(path, data, _callback, reqType, flag);
		table.batchSelect(current);
	},
	tableBatchSelectSI: function (
		tableId,
		objFct,
		SIID,
		req,
		flag,
		current = 1,
		callback,
		reqType,
		assistBody
	) {
		let table = this.getCmp(tableId, objFct);
		if (!table) return;

		// let prm = PrmFactory.getPrm(SIID);
		// if (!prm || !prm.guid) return;

		//let path = sgiConfig.service + "/" + prm.url;//服务地址
		let path = sgiSrvUrl.service + "/bdl/invoke/" + SIID;

		// let data, inInst, outInst;
		// let cfgs = prm.cldSet || [];
		// cfgs.some(cfg => {
		// 	let io = cfg.iobType;//输入输出类型
		// 	let instance = cfg.oKey;//实例名
		// 	if (!inInst && io == "I") {
		// 		inInst = instance;
		// 		data = objFct.get(instance);
		// 	}
		// 	if (!outInst && io == "O") {
		// 		outInst = instance;
		// 	}
		// 	return inInst && outInst;
		// });
		let data = req;
		let _callback = (res) => {
			// 成功，对象工厂赋值
			if (res && res.head && res.head.code == "0000")
				// objFct.set(outInst, res.body);
				// 同上回调
				callback(res);
		};
		table.setBatchInfo(path, data, _callback, reqType, flag, assistBody);
		table.batchSelect(current);
	},
	/**
	 * 获取表格已选中/已勾选数据
	 * @param  {string} tableId 表格控件id
	 * @param  {ObjFactory} objFct 对象工厂
	 * @return {object[]} 已选中/已勾选行对象数组
	 * 
	 * @group table
	 * @example
	 * tool.setTbSelType('cid_table', objFct);
	 */
	getTbSels: function (tableId, objFct) {
		var table = this.getCmp(tableId, objFct);
		if (!table) {
			return;
		}
		return table.getTbSels();
	},
	/**
	 * 设置表格勾选
	 * key值如果不为空，遍历所有节点，根据key属性，找到与records相同的值，这些records checked
	 * 如果key为空，默认这些record就是树上的records，直接选中
	 * @param {string} tableId 表格控件id
	 * @param {object[]} records 要勾选的表格数据数组
	 * @param {string} [key] 勾选数据匹配依据的key，主键标识
	 * @param {ObjFactory} objFct 对象工厂
	 * 
	 * @group table
	 * @example
	 * tool.setTbSels('cid_table', [{id:'1'}], 'id', objFct);
	 */
	setTbSels: function (tableId, records, key, objFct) {
		if (!records) return;
		var table = this.getCmp(tableId, objFct);
		if (!table) {
			return;
		}
		if (key) {
			let inRecords = table.getTbDataByKey(records, key);
			table.setTbSels(inRecords);
		} else {
			table.setTbSels(records);
		}
	},
	/**
	 * 获取表格所有数据
	 * @deprecated 不推荐使用，可直接从表格绑定对象工厂中取值
	 * @param  {string} tableId 表格控件id
	 * @param  {ObjFactory} objFct 对象工厂
	 * @return {array} 表格数据对象数组
	 * 
	 * @group table
	 * @example
	 * tool.getTbData('cid_table', objFct);
	 */
	getTbData: function (tableId, objFct) {
		var table = this.getCmp(tableId, objFct);
		if (!table) {
			return;
		}
		return table.getTbData();
	},
	/**
	 * 向表格中添加新数据
	 * @param  {string} tableId 表格控件id
	 * @param  {object} newData 要添加的数据对象
	 * @param  {ObjFactory} objFct 对象工厂
	 * 
	 * @group table
	 * @example
	 * var newData = {ap:"ap2",tt:"tt2",ss:"ss2",sc:"sc2"};
	 * tool.addTbNewData("cid_tb_table_0004", newData, objFct);
	 */
	addTbNewData: function (tableId, newData, objFct) {
		var table = this.getCmp(tableId, objFct);
		if (!table) {
			return;
		}
		table.addTbNewData(newData);
	},
	/**
	 * 删除表格选中数据
	 * @param  {string} tableId 表格控件id
	 * @param  {ObjFactory} objFct 对象工厂
	 * 
	 * @group table
	 * @example
	 * tool.delTableSel("cid_tb_table_0004", objFct);
	 */
	delTableSel: function (tableId, objFct) {
		var table = this.getCmp(tableId, objFct);
		if (!table) {
			return;
		}
		table.delTableSel();
	},
	/**
	 * 删除表格指定行数据
	 * @param  {string} tableId 表格控件id
	 * @param  {object} delData 要删除的单行数据
	 * @param  {ObjFactory} objFct 对象工厂
	 * 
	 * @group table
	 * @example
	 * tool.delTableObj("tableId", record, objFct);
	 */
	delTableObj: function (tableId, delData, objFct) {
		var table = this.getCmp(tableId, objFct);
		if (!table) {
			return;
		}
		table.delTableObj(delData);
	},
	/**
	 * 设置表格加载状态【不建议使用该方法，建议使用通用setLoading方法，传参相同】
	 * @param {string} tableId 表格id
	 * @param {boolean|object} loading 加载状态(object为antd-spin组件描述)
	 * @param {ObjFactory} objFct 对象工厂
	 * 
	 * @group table
	 * @example
	 * tool.setTableLoading("cid_tb_table_0004", true||false, objFct);
	 */
	setTableLoading: function (tableId, loading, objFct) {
		var table = this.getCmp(tableId, objFct);
		if (!table) return;
		table.setLoading(loading);
	},

	/**************** 以上表格控件方法部分 ****************/
	/**************** 以下页面处理部分 ****************/

	/**
	 * 切换选项卡/层叠面板/折叠面板到指定itemId的页面
	 * @param  {string} ctnId 容器控件id
	 * @param  {string} itemId 子面板id
	 * @param  {ObjFactory} objFct 对象工厂
	 * @param  {function} callback 面板激活后/加载后回调
	 * 
	 * @group tabs
	 * @example
	 * // 同步加载所有面板，激活方法
	 * tool.setActiveItem("ctnId", "panelId", objFct);
	 * // TODO something
	 * // 异步加载其余面板，激活方法
	 * tool.setActiveItem("ctnId", "panelId", objFct, ()=>{
	 * 	// TODO something
	 * });
	 */
	setActiveItem: function (ctnId, itemId, objFct, callback) {
		var activePanel = this.getCmp(itemId, objFct);
		if (activePanel) {
			// 面板已创建
			activePanel.props.setActiveWV(itemId);
			if (callback && typeof callback === "function") {
				callback(activePanel, objFct);
			}
		} else {
			// 面板未创建
			var container = this.getCmp(ctnId, objFct);
			if (!container) {
				return;
			}
			container.setActiveItem(itemId, callback);
		}
	},
	/**
	 * 激活指定wvId面板（选项卡/层叠面板）
	 * @param  {string} wvId 面板id
	 * @param  {ObjFactory} objFct 对象工厂
	 * 
	 * @group tabs
	 * @example
	 * tool.setActiveWV("cid_wv_sc_scEditor", objFct);
	 */
	setActiveWV: function (wvId, objFct) {
		var container = this.getCmp(wvId, objFct);
		if (container) {
			container.props.setActiveWV(wvId);
		} else {
			let allWVItems = objFct.get(sgiConstants.allWVItemKey);
			if (allWVItems && allWVItems[wvId]) {
				let { moduleDesc, module, parentModule } = allWVItems[wvId];
				if (parentModule) parentModule.setActiveItem(wvId);
			}
		}
	},
	/**
	 * 获取当前激活面板的组件标识
	 * @param  {string} ctnId 容器id
	 * @param  {ObjFactory} objFct 对象工厂
	 * @return {string} 当前激活面板的组件id
	 * 
	 * @group tabs
	 * @example
	 * var str = tool.getActiveItem('tab_editor', objFct);
	 */
	getActiveItem: function (ctnId, objFct) {
		var container = this.getCmp(ctnId, objFct);
		if (!container) {
			return;
		}
		return container.getActiveItem(ctnId);
	},
	/**
	 * 动态设置选项卡项(根据子组件描述)
	 * @author hanzb
	 * @param {string} tabsId 选项卡id
	 * @param {array} sonDescs 子组件描述数组
	 * @param {ObjFactory} objFct 对象工厂
	 * @param {string} activeKey 激活key
	 * 
	 * @group tabs
	 * @example
	 * const propss = [
	 *	{ tab: "发卡数", key: "cid_panel_card_number" },
	 *	{ tab: "激活数", key: "cid_panel_active_number" }
	 * ];
	 * tool.setTabsItemsByDescs('cid_tab', propss, objFct, 'cid_tab_panel')
	 */
	setTabsItemsByDescs: function (tabsId, sonDescs, objFct, activeKey) {
		var tabs = this.getCmp(tabsId, objFct);
		if (!tabs) {
			return;
		}
		tabs.setTabsItemsByDescs(sonDescs, activeKey);
	},
	/**
	 * 动态设置选项卡项(根据TabPane属性)
	 * @author hanzb
	 * @param {string} tabsId 选项卡id
	 * @param {array} propss TabPane属性
	 * @param {ObjFactory} objFct 对象工厂
	 * @param {string} activeKey 激活key
	 * 
	 * @group tabs
	 * @example
	 * const propss = [
	 *	{ tab: "发卡数", key: "cid_panel_card_number" },
	 *	{ tab: "激活数", key: "cid_panel_active_number" }
	 * ];
	 * tool.setTabsItemsByTabPaneProps("cid_tabs_dynamic", propss, objFct, "cid_panel_card_number");
	 */
	setTabsItemsByTabPaneProps: function (tabsId, propss, objFct, activeKey) {
		var tabs = this.getCmp(tabsId, objFct);
		if (!tabs) {
			return;
		}
		tabs.setTabsItemsByTabPaneProps(propss, activeKey);
	},
	/**
	 * 动态设置选项卡面板title
	 * @param {string} tabsId 选项卡id
	 * @param {string} tabId 选项卡子面板组件标识
	 * @param {string|Element} title 标题名或组件
	 * @param {ObjFactory} objFct 对象工厂
	 * 
	 * @group tabs
	 * @example
	 * tool.setTabsTabTitle('cid_tab', 'cid_tab_panel', '标题'，objFct)
	 */
	setTabsTabTitle: function (tabsId, tabId, title, objFct) {
		var tabs = this.getCmp(tabsId, objFct);
		if (!tabs) return;
		tabs.setTabTitle(tabId, title);
	},
	/**
	 * 获取对象值
	 * @param  {object} obj 对象
	 * @param  {string} code 属性编码key
	 * @return {object} 属性值
	 * 
	 * @group object
	 * @example
	 * var value = tool.getVal(dv,"te")
	 */
	getVal: function (obj, code) {
		if (!obj || !code) {
			return;
		}
		return obj[code];
	},
	/**
	 * 设置对象值
	 * @param  {object} obj 对象
	 * @param  {string} code 属性编码key
	 * @param  {object} value 属性值
	 * 
	 * @group object
	 * @example
	 * tool.setVal(currentSCNode,"teid","111");
	 */
	setVal: function (obj, code, value) {
		if (!obj || !code) {
			return;
		}
		obj[code] = value;
	},
	panelAddUcvNewObject: function (wvid, ucvid, objFct, flag, transferData) {
		var panel = this.getCmp(wvid, objFct);
		if (!panel) {
			return;
		}
		// 设置添加列表
		if (!panel.addUCVList) {
			panel.addUCVList = {};
		}
		// 是否清空重新添加
		if (flag) {
			panel.props.moduleDesc.customCldSet = [];
			panel.addUCVList = {};
		} else {
			// 判断是否已经添加过了 添加过了 返回不再添加
			if (panel.addUCVList[ucvid]) {
				return;
			}
		}
		//获取 uid信息
		var uiJson = PrmFactory.getPrm(ucvid);
		if (!uiJson) {
			return;
		}
		if (!panel.props.moduleDesc.customCldSet) {
			panel.props.moduleDesc.customCldSet = [];
		}
		uiJson.transferData = transferData;
		panel.props.moduleDesc.customCldSet.push(uiJson);
		panel.refresh();
		// 设置添加标示
		panel.addUCVList[ucvid] = true;
	},
	/**
	 * （往普通面板中）嵌入ui面板
	 * @param  {string} wvid 父面板id
	 * @param  {string} ucvid 要嵌入的guid
	 * @param  {ObjFactory} objFct 对象工厂
	 * @param  {boolean} flag 是否清空重新添加
	 * 
	 * @group panel
	 * @example
	 * tool.panelAddUcv("cid_test", "rnt_UI_webTest_0003", objFct);
	 */
	panelAddUcv: function (wvid, ucvid, objFct, flag) {
		var panel = this.getCmp(wvid, objFct);
		if (!panel) {
			return;
		}

		// 设置添加列表
		if (!panel.addUCVList) {
			panel.addUCVList = {};
		}

		// 是否清空重新添加
		if (flag) {
			panel.props.moduleDesc.cldSet = [];
			panel.addUCVList = {};
		} else {
			// 判断是否已经添加过了 添加过了 返回不再添加
			if (panel.addUCVList[ucvid]) {
				return;
			}
		}

		var uiJson = PrmFactory.getPrm(ucvid);
		if (!uiJson) {
			return;
		}

		if (!panel.props.moduleDesc.cldSet) {
			panel.props.moduleDesc.cldSet = [];
		}
		panel.props.moduleDesc.cldSet.push(uiJson);
		panel.refresh();
		// 设置添加标示
		panel.addUCVList[ucvid] = true;
	},
	/**
	 * （从普通面板中）删除指定ui面板
	 * @param  {string} wvid 父面板id
	 * @param  {string} ucvid 要删除ui的guid
	 * @param  {ObjFactory} objFct 对象工厂
	 * 
	 * @group panel
	 * @example
	 * tool.panelRemoveUcv('cid_wv', 'sm_UI_text_0001', objFct);
	 */
	panelRemoveUcv: function (wvid, ucvid, objFct) {
		var panel = this.getCmp(wvid, objFct);
		if (!panel) {
			return;
		}
		panel.remove(ucvid);
	},

	/**
	 * 平铺组件刷新方法
	 * @author hanzb
	 * @param {string} tileId 平铺组件id
	 * @param {ObjFactory} objFct 对象工厂
	 * @param {any} parameters 保留第三参数，暂无功能
	 * 
	 * @group tile
	 * @example 例：
	 *  // 平铺组件数据
	 *	objFct.set("db_tile_task_overview", [{
	 *		type: "book", color: "blue", num: 0, title: "总任务数"
	 *	}, {
	 *		type: "phone", color: "orange", num: 0, title: "计划拨打数"
	 *	}]);
	 *	tool.refreshTile("cid_tile_task_overview", objFct);
	 *  // 自定义子组件渲染事件填写每一个小单元需要渲染的内容
	 */
	refreshTile: function (tileId, objFct, parameters) {
		var tile = this.getCmp(tileId, objFct);
		if (!tile) {
			return;
		}
		var tileData = objFct.get(tile.state.insName) || [];
		tile.refreshByData(tileData, parameters);
	},

	/**
	 * 通用图表刷新方法
	 * @author hanzb
	 * @param {string} echartsId 图表id
	 * @param {ObjFactory} objFct 对象工厂
	 * @param {any} parameters 保留第三参数，暂无功能
	 * 
	 * @group echarts
	 * @example 例：
	 * objFct.set("db_echarts_my_achievement", faka.details);
	 * tool.refreshEcharts("cid_echarts_my_achievement", objFct);
	 */
	refreshEcharts: function (echartsId, objFct, parameters) {
		var echarts = this.getCmp(echartsId, objFct);
		if (!echarts) {
			return;
		}
		var echartsData = objFct.get(echarts.state.insName) || [];
		echarts.refreshByData(echartsData, parameters);
	},
	/**
	 * 设置容器类组件加载状态
	 * @param {string} ctnId 组件id(目前仅支持普通面板、表格)
	 * @param {boolean|object} loading 加载状态(object为antd-spin组件描述)
	 * @param {ObjFactory} objFct 对象工厂
	 * 
	 * @group panel
	 * @example 例：
	 * tool.setLoading('cid_wv', true||false, objFct);
	 */
	setLoading: function (ctnId, loading, objFct) {
		var ctn = this.getCmp(ctnId, objFct);
		if (!ctn) return;
		ctn.setLoading(loading);
	},

	/**************** 以上页面处理部分 ****************/
	/**************** 以下控件部分 ****************/

	/**
	 * 根据控件id，设置控件是否禁用
	 * @param {string} ctlId 控件id
	 * @param {boolean} disabled 是否禁用
	 * @param {ObjFactory} objFct 对象工厂
	 * 
	 * @group ctl
	 * @example 例：
	 * 表单元素需要禁用时、表单回显时，或由禁用改为可用时
	 * tool.setDisabled("cid_search",true,objFct);
	 * tool.setDisabled("cid_btn",false,objFct);
	 */
	setDisabled: function (ctlId, disabled, objFct) {
		var ctl = this.getCmp(ctlId, objFct);
		if (!ctl) {
			return;
		}
		ctl.setDisabled(disabled);
	},
	/**
	 * 根据控件id，设置控件是否隐藏
	 * @param {string} ctlId 控件id
	 * @param {boolean} hidden 是否隐藏
	 * @param {ObjFactory} objFct 对象工厂
	 * 
	 * @group ctl
	 * @example 例：
	 * 表单元素需要分情况需要隐藏或显示时
	 * tool.setHidden("cid_btn",true,objFct);
	 * tool.setHidden("cid_btn",false,objFct);
	 */
	setHidden: function (ctlId, hidden, objFct) {
		var ctl = this.getCmp(ctlId, objFct);
		if (!ctl) {
			return;
		}
		ctl.setHidden(hidden);
	},
	/**
	 * 设置组件是否必填
	 * @param {string} ctlId 组件id
	 * @param {boolean} required 是否必填
	 * @param {ObjFactory} objFct 对象工厂
	 * 
	 * @group ctl
	 * @example 例：
	 * 表单元素需要动态设置是否必填时
	 * tool.setRequired("cid_input",true,objFct);
	 * tool.setRequired("cid_input",false,objFct);
	 */
	setRequired: function (ctlId, required, objFct) {
		var ctl = this.getCmp(ctlId, objFct);
		if (!ctl) {
			return;
		}
		ctl.setRequired(required);
	},
	/**
	 * 设置组件校验状态
	 * @param {string} ctlId 组件id
	 * @param {string} message 提示信息
	 * @param {string} status 组件校验状态，可选'success','warning','error','validating'
	 * @param {boolean} hasFeedback 是否显示校验图标
	 * @param {ObjFactory} objFct 对象工厂
	 * 
	 * @group ctl
	 * @example 例：
	 * 表单元素需要动态设置校验时
	 * tool.setValidate("cid_input","输入格式不正确","warning",true,objFct);
	 */
	setValidate: function (ctlId, message, status, hasFeedback, objFct) {
		var ctl = this.getCmp(ctlId, objFct);
		if (!ctl || !ctl.setValidate) return;
		ctl.setValidate(message, status, hasFeedback);
	},
	/**
	 * 设置控件显示值
	 * @param  {string} ctlId 控件id
	 * @param  {object} value 显示值
	 * @param  {object} objFct 对象工厂
	 * 
	 * @group ctl
	 * @example 例：
	 * 动态设置表单元素显示值
	 * tool.ctlSetValue("cid_search",'显示值',objFct); 
	 */
	ctlSetValue: function (ctlId, value, objFct) {
		var ctl = this.getCmp(ctlId, objFct);
		if (!ctl) {
			return;
		}
		ctl.setValue(value);
	},
	/**
	 * 组件通用赋值方法，需组件提供setValue接口
	 * @param {string} ctlId 组件id
	 * @param {string|object} value 组件新值
	 * @param {ObjFactory} objFct 对象工厂
	 * @param {object} parameters 相关参数
	 * 
	 * @group ctl
	 * @example 例：
	 * 通用设置组件显示值
	 * tool.setValue("cid_search",'显示值',objFct,{}); 
	 */
	setValue: function (ctlId, value, objFct, parameters) {
		var ctl = this.getCmp(ctlId, objFct);
		if (!ctl) return;
		ctl.setValue(value, parameters);//赋值
		if (ctl.validate) ctl.validate();//校验

		//刷新对象工厂值
		var { moduleDesc, bdInst } = ctl.props;
		let attname = moduleDesc.c
		if (ctl.setBindValue) ctl.setBindValue(attname, bdInst, objFct, value);//刷新绑定值
	},
	// /**
	//  * 组件通用赋值方法（并进行校验）
	//  * @param {string} ctlId 组件id
	//  * @param {string|object} value 组件新值
	//  * @param {ObjFactory} objFct 对象工厂
	//  * @param {object} parameters 相关参数
	//  */
	// setValueValid: function (ctlId, value, objFct, parameters) {
	//     var ctl = this.getCmp(ctlId, objFct);
	//     if (!ctl) return;
	//     ctl.setValue(value, parameters);
	//     ctl.validate();

	//     //刷新对象工厂值
	//     var { moduleDesc, bdInst } = ctl.props;
	//     let attname = moduleDesc.c
	//     ctl.setBindValue(attname, bdInst, objFct, value);
	// },
	/**
	 * 组件通用取值方法，需组件提供getValue接口
	 * @param {string} ctlId 组件id
	 * @param {ObjFactory} objFct 对象工厂
	 * @param {object} parameters 相关参数
	 * 
	 * @group ctl
	 * @example 例：
	 * 通用获取组件值
	 * tool.getValue("cid_search",objFct,{}); 
	 */
	getValue: function (ctlId, objFct, parameters) {
		var ctl = this.getCmp(ctlId, objFct);
		if (!ctl) return;
		return ctl.getValue(parameters);
	},
	/**
	 * 组件标题设置方法，需组件自身提供setTitle接口，目前用于面板(card)的标题设置
	 * @param {string} ctlId 组件id
	 * @param {string|Element} title 组件标题
	 * @param {ObjFactory} objFct 对象工厂
	 * @param {object} parameters 相关参数
	 * 
	 * @group card
	 * @example 例：
	 * let subTitle = tool.createElement("span", { style: { color: "#9eacb4", fontSize: 13, marginLeft: 5 } }, year + "年");
	 * tool.setTitle("cid_view_panel_overdue", ["不良逾期率分析", subTitle], objFct);
	 */
	setTitle: function (ctlId, title, objFct, parameters) {
		var ctl = this.getCmp(ctlId, objFct);
		if (!ctl || !ctl.setTitle) return;
		ctl.setTitle(title, parameters);
	},
	/**
	 * 组件通用刷新方法，需组件自身提供refresh接口
	 * @param {string} ctlId 组件id
	 * @param {ObjFactory} objFct 对象工厂
	 * @param {object} parameters 相关参数
	 * 
	 * @group ctl
	 * @example 例：
	 * tool.refresh('cid_form', objFct);
	 * tool.refresh('cid_table', objFct);
	 */
	refresh: function (ctlId, objFct, parameters) {
		var ctl = this.getCmp(ctlId, objFct);
		if (!ctl) return;
		return ctl.refresh(parameters);
	},
	/**
	 * 控件通用函数调用方法
	 * @param {string} ctlId 控件id
	 * @param {string} funName 调用函数名称
	 * @param {ObjFactory} objFct 对象工厂
	 * @param  {...any} parameters 函数传参
	 * 
	 * @group _global_
	 * @example 例：
	 * tool.callCtlFun('cid_tree', 'expand', objFct, 'cid_tree', record, objFct);
	 * 
	 * let type;
	 * switch (activeKey) {
	 * 	case "cid_fold_panel_event": 
	 *	 type = "事件"; 
	 *   break;
	 *	default: 
	 *   type = "事件"; 
	 *   break;
	 * }
	 * tool.callCtlFun("cid_btn_add_event", "setText", objFct, `添加${type}`);
	 */
	callCtlFun: function (ctlId, funName, objFct, ...parameters) {
		var ctl = this.getCmp(ctlId, objFct);
		if (!ctl) return;
		if (!ctl[funName]) {
			sgiLogger.debug(`在组件【${ctlId}】中找不到函数名为【${funName}】的方法，请检查代码是否正确`);
			return;
		}
		return ctl[funName](...parameters);
	},

	/**************** 以上弹出窗部分 ****************/
	/**************** 以下页面处理部分 ****************/

	/**
	 * 下拉窗/单选组/复选组件刷新选项数组
	 * @param {string} comboxid 下拉窗/单选组/复选组控件id
	 * @param {object[]} newlist 组件新的选项数组
	 * @param {string} codeCode 作为实际取值的属性key
	 * @param {string} textCode 作为显示的属性key
	 * @param {ObjFactory} objFct 对象工厂
	 * 
	 * @group combox
	 * @example 例：
	 * 动态刷新下拉窗等的选项数据
	 * var newlist = [{c:"1",te:"男"}, {c:"2",te:"女"}]; 
	 * tool.refreshComboxByid("cid_combox", newlist, "c", "te", objFct);
	 */
	refreshComboxByid: function (comboxid, newlist, codeCode, textCode, objFct) {
		if (!comboxid || !newlist) {
			return;
		}
		var combox = this.getCmp(comboxid, objFct);
		if (!combox) {
			return;
		}
		var list = newlist.filter(l => l[codeCode || "c"]);//去除codeCode属性为null产生的异常数据
		combox.dynamicRefreshCombox(list, codeCode, textCode);
	},


	/**
	 * 动态设置下拉框 显示列表 筛选部分显示
	 * @param {*} comboxid  下拉框id
	 * @param {*} showList 要显示的业务数组
	 * @param {*} key  业务要在下拉框中 保存的属性id
	 * @param {*} objFct 
	 * 
	 * @group combox
	 * @example 例：
	 * 筛选下拉窗的部分显示数据
	 * var newlist = [{c:"1",te:"男"}, {c:"2",te:"女"}]; 
	 * tool.refreshSelectShowsList("cid_combox", newlist, "c", objFct);
	 */
	refreshSelectShowsList: function (comboxid, showList, key, objFct) {
		//获取下拉框 
		if (!comboxid || !showList || !key || !objFct) {
			return;
		}
		var combox = this.getCmp(comboxid, objFct);
		if (!combox) {
			return;
		}
		let selectShowList = [];
		showList.forEach(element => {
			selectShowList.push(element[key])
		});
		combox.state.shows = selectShowList;
		combox.fitSelectOption(combox.props.moduleDesc);
		combox.setState({ loading: false });
	},

	/**
	 * 下拉树控件刷新选项数组
	 * @param {string} comboxid 下拉树控件id
	 * @param {object[]} newlist 下拉树新的选项数组
	 * @param {string} codeCode 作为实际取值的属性key
	 * @param {string} textCode 作为显示的属性key
	 * @param {ObjFactory} objFct 对象工厂
	 * @param {string} [childCode="cldSet"] 子节点属性标识，默认“策略的Set”
	 * 
	 * @group comboxTree
	 * @example 例：
	 * 动态刷新下拉树的选项数据
	 * var data = tool.ctTrStrByData(list, 'pk', 'parentPk', null, null, objFct); 
	 * tool.refreshComboxTreeByid("cid_wfType", data, "pk", "className", objFct, "cldSet");
	 */
	refreshComboxTreeByid: function (comboxid, newlist, codeCode, textCode, objFct, childCode) {
		if (!comboxid || !newlist) {
			return;
		}
		var combox = this.getCmp(comboxid, objFct);
		if (!combox) {
			return;
		}
		combox.dynamicRefreshCombox(newlist, codeCode, textCode, childCode);
	},

	/**
	 * 刷新步骤条显示节点
	 * @param {string} stepsId 步骤条id
	 * @param {string[]} showKeys 要显示的节点key数组
	 * @param {ObjFactory} objFct 对象工厂
	 * 
	 * @group steps
	 * @example 例：
	 * tool.setStepsShowKeys("cid_step", ["1", "9"], objFct);
	 */
	setStepsShowKeys: function (stepsId, showKeys, objFct) {
		if (!showKeys) return;

		var steps = this.getCmp(stepsId, objFct);
		if (!steps) return;

		steps.setShowKeys(showKeys);
	},

	/**
	 * 设置禁用项，设置不可选项
	 * @param {string} comboxid 下拉窗控件id
	 * @param {object[]} disabledList 要禁用的选项数组
	 * @param {string} codeCode 匹配属性key，依据disabledList中每个对象的该属性值进行匹配
	 * @param {ObjFactory} objFct 对象工厂
	 * 
	 * @group combox
	 * @example 例：
	 * tool.setDisabledItems("cid_combox", [{id:'1', id:'2'}], 'id', objFct);
	 */
	setDisabledItems: function (comboxid, disabledList, codeCode, objFct) {
		if (!comboxid || !disabledList) {
			return;
		}
		var combox = this.getCmp(comboxid, objFct);
		if (!combox) {
			return;
		}
		combox.setDisabledItems(disabledList, codeCode);
	},

	/**************** 以上控件处理部分 ****************/
	/**************** 以下通用部分 ****************/

	/**
	   * scCode: list codeCode textCode noclearFlag 如果 scCode存在 是否不清空
	   */
	/**
	 * 设置标准代码选项数组（注意：该操作会改变所有使用该标准代码的控件选项内容）
	 * @param {string} scCode 标准代码guid
	 * @param {object[]} list 新的子节点数组
	 * @param {string} codeCode list中作为实际值的属性key
	 * @param {string} textCode list中作为展示值的属性key
	 * @param {boolean} [noclearFlag=false] 是否保留原有选项数组，默认为false不保存
	 * @param {string[]} [code] list中用作额外辅助的数据code数组
	 * 
	 * @group combox
	 * @example 例：
	 * 动态设置标准代码显示内容
	 * var scCode = "Emos_SC_plan_310010", list = [{useId:'1',userNickname:'用户',userAge:20}], codeCode = "userId", textCode = "userNickname", noclearFlag = false;
	 * tool.setSCList(scCode, list, codeCode, textCode, noclearFlag, ['userAge']);
	 */
	setSCList: function (scCode, list, codeCode = "c", textCode = "te", noclearFlag, otherCodes) {
		if (!list || list.length < 1) {
			return;
		}
		//检查otherCodes如果存在，是否为数组
		if (otherCodes && !(otherCodes instanceof Array)) {
			sgiLogger.log("传入的额外辅助数据不是数组结构");
			return;
		}

		var roleList = list.filter(l => l[codeCode]);//去除codeCode属性为null产生的异常数据
		var scList = StandardCode.getSC(scCode);

		if (!noclearFlag) {
			scList.splice(0, scList.length);
		}
		if (!scList) {
			return;
		}
		roleList.forEach(record => {
			var addflag = true;
			if (noclearFlag) {
				// 查看 数组中是否存在 改record
				for (var i = 0; i < scList.length; i++) {
					var tmpitem = scList[i];
					var newc;
					newc = record[codeCode];
					var c;
					c = tmpitem.sc;
					if (newc === c) {
						addflag = false;
						break;
					}
				}
			}
			if (addflag) {
				var node = {};
				var c, te;
				c = record[codeCode];
				te = record[textCode];
				node.sc = c;
				node.n = te;
				node.te = te;
				node.c = c;

				if (otherCodes) {
					otherCodes.forEach(element => {
						if (!element) return;
						node[element] = record[element];
					});
				}
				scList.push(node);
			}
		});
		StandardCode.onSCChange(scCode); //执行订阅事件
		return scList;
	},

	setSCtree :function (scCode, list, codeCode = "c", textCode = "te", noclearFlag, otherCodes) {
		if (!list || list.length < 1) {
			return;
		}
		//检查otherCodes如果存在，是否为数组
		if (otherCodes && !(otherCodes instanceof Array)) {
			sgiLogger.log("传入的额外辅助数据不是数组结构");
			return;
		}
	
		var roleList = list.filter(l => l[codeCode]);//去除codeCode属性为null产生的异常数据
		var scList = StandardCode.getSC(scCode);
	
		if (!noclearFlag) {
			scList.splice(0, scList.length);
		}
		if (!scList) {
			return;
		}
		 //递归处理
		 next(roleList,scList);
	
		function next(roleList,newList) {
			roleList.forEach(record => {
				let addflag = true;
				if (noclearFlag) {
					// 查看 数组中是否存在 改record
					for (var i = 0; i < scList.length; i++) {
						var tmpitem = scList[i];
						var newc;
						newc = record[codeCode];
						var c;
						c = tmpitem.sc;
						if (newc === c) {
							addflag = false;
							break;
						}
					}
				}
				if (addflag) {
					let node = {};
					let c, te;
					c = record[codeCode];
					te = record[textCode];
					node.sc = c;
					node.n = te;
					node.te = te;
					node.c = c;
					if (otherCodes) {
						otherCodes.forEach(element => {
							if (!element) return;
							node[element] = record[element];
						});
					}
					let cldSet = record.cldSet;
					if (cldSet && cldSet.length > 0) {
						node.cldSet = [];
						next(cldSet, node.cldSet)
					}
					newList.push(node);
				}
			});
		}
		StandardCode.onSCChange(scCode); //执行订阅事件
		return scList;
	}, 

	/**
	 * 设置标准代码
	 * @param {string} scCode 标准代码guid
	 * @param {object} scPrm 要设置的参数
	 * @param {string} codeCode 作为存储的key
	 * @param {string} textCode 作为显示的key
	 * @param {boolean} noclearFlag 是否保留现有下拉项
	 * 
	 * @group sc
	 * @example 例：
	 * 动态设置标准代码选项参数
	 * tool.setSCPrm('sm_sc_001', {id:'1', text:'一'}, 'id', 'text', true)
	 */
	setSCPrm: function (scCode, scPrm, codeCode, textCode, noclearFlag) {
		if (!scCode || !scPrm) return;

		let oldPrm = StandardCode.getFullSC(scCode) || {};
		if (!noclearFlag) {
			for (const key in oldPrm) {
				delete oldPrm[key];
			}
		}

		let newSCPrm = mergeObj(oldPrm, scPrm);
		StandardCode.setSC(scCode, newSCPrm);

		function mergeObj(target, source) {
			// 目标和源相同，直接返回
			if (target === source) return target;
			// 分情况处理
			if (Object.prototype.toString.call(target) === '[object Object]' && Object.prototype.toString.call(source) === '[object Object]') {
				if (codeCode) source["c"] = source[codeCode];
				if (textCode) source["te"] = source[textCode];
				for (let key in source) {
					if (target[key] === source[key]) continue;//相同，跳过
					if (!target[key]) target[key] = source[key];//target属性不存在，直接赋值
					else target[key] = merge(target[key], source[key]);//target属性存在，合并
				}
			} else if (Object.prototype.toString.call(target) === '[object Array]' && Object.prototype.toString.call(source) === '[object Array]') {
				for (let i = 0; i < source.length; i++) {
					if (codeCode) source["c"] = source[codeCode];
					if (textCode) source["te"] = source[textCode];
					if (target[i] === source[i]) continue;//相同，跳过
					if (!target[i]) target.push(source[i]);//target元素不存在，直接添加
					else target[i] = merge(target[i], source[i]);//target元素存在，合并
				}
			} else {//其他情况，直接赋值
				target = source;
			}
			// 返回target
			return target;
		}
	},
	/**
	 * 根据当前值 获取显示内容
	 * @param {*} value 
	 * @param {*} scId 
	//  * @param {*} comboxList 
	 * @example 例：
	 * tool.getSCShowValue('1', 'sm_sc_001');
	 */
	getSCShowValue(value, scId) {

		if (!scId || !value) {
			sgiLogger.debug(`输入内容scId或者value不存在`);
			return;
		}

		var comboBoxData = StandardCode.getSC(scId) || [];

		if (!comboBoxData || comboBoxData.length.length == 0) {
			sgiLogger.debug(`输入内容scId获取不到标准代码`);
			return;
		}

		var newcomboBoxData = [];
		if (value && !(value instanceof Array)) {
			var valueList = value.split(",");//拆分
			for (var i = 0; i < valueList.length; i++) {
				var uceC = valueList[i];
				newcomboBoxData.push(uceC);
			}
		} else if (value) {
			newcomboBoxData = value;
		}

		let showValue = [];

		for (let j = 0; j < newcomboBoxData.length; j++) {
			for (let i = 0; i < comboBoxData.length; i++) {
				var item = comboBoxData[i];
				if (newcomboBoxData[j] == item["c"]) {
					showValue.push(item["te"]);
					break;
				} else if (i === comboBoxData.length - 1) {
					// 最后一个仍然不匹配
					showValue.push(newcomboBoxData[j]);
				}
			}
		}

		return showValue.join(",");
	}
}

Object.assign(tool, sgiCommon, { Array: sgiCommon.sgiArray });
Object.assign(tool, sgiClient.sgiClient);
// 初始化
if (!window.tool) window.tool = tool;
// 追加
else Object.assign(window.tool, tool);
// 导出（window.tool与tool的引用并不一定相同，已window.tool为主，tool仅作为定义工具集函数使用，像window.tool内追加）
let wTool = window.tool;
export { wTool as tool };
export default wTool;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCommon/sgiRunningCommon.js